import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  useMediaQuery
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import API from "../../../../api";
import { colors } from "../../../../theme"; // IMPORTA i tokens
import { startToast, updateToastSuccess, updateToastError } from "../../../../utils/notification-loading";
//import { startToast, updateToastSuccess, updateToastError, updateToastWarning } from '../../../../utils/notification-loading';

const AddAccountDialog = ({ open, onClose, matricola, onAccountAdded }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [email, setEmail] = useState("");
  const [type, setType] = useState("admin");

  const handleSubmit = () => {
    const payload = {
      serial_number: matricola,
      email,
      type,
    };
    startToast()
    API.addAccountLecs(payload)
      .then(() => {
        updateToastSuccess("Account added successfully");
        //renderNotification("error", "error", "Account added successfully")
        onAccountAdded();
        onClose();
      })
      .catch(() => {
        updateToastError("Failed to add account");
        //renderNotification("error", "error", "Failed to add account")
      });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: "#1e1e1e",
          color: "#fff",
          borderRadius: 2,
          px: 2,
          py: 1,
        },
      }}
    >
      <DialogTitle sx={{ color: "#fff" }}>Add Account</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 1 }}>
        <TextField
                label="Email"
                type="email"
                fullWidth
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                margin="dense"
                InputLabelProps={{
                    shrink: true,
                    sx: {
                    color: "#ccc",
                    overflow: "visible",
                    zIndex: 1,
                    },
                }}
                InputProps={{
                    sx: {
                    color: "#fff",
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#555",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#888",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: colors.lightBlue[600],
                    },
                    },
                }}
        />
        <FormControl fullWidth>
            <InputLabel sx={{ color: "#ccc" }}>Account Type</InputLabel>
            <Select
            value={type}
            label="Account Type"
            onChange={(e) => setType(e.target.value)}
            sx={{
                color: "#fff",
                ".MuiOutlinedInput-notchedOutline": {
                borderColor: "#555",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: colors.lightBlue[600],
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#888",
                },
                ".MuiSvgIcon-root": {
                color: "#ccc",
                },
            }}
            >
            <MenuItem value="admin">Primary</MenuItem>
            <MenuItem value="secondary">Secondary</MenuItem>
            </Select>
        </FormControl>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            color: "#ccc",
            borderColor: "#555",
            "&:hover": {
              borderColor: "#999",
              backgroundColor: "rgba(255,255,255,0.05)",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{
            color: "#fff",
            fontWeight: 600,
            textTransform: "none",
            "&:hover": {
              backgroundColor: colors.lightBlue[400],
            },
          }}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddAccountDialog;
